import React from "react";
import {
	makeStyles,
	Dialog,
	DialogContent,
	DialogContentText,
	DialogTitle,
	DialogActions,
	IconButton,
	Slide,
	Fab, Tooltip, ClickAwayListener
} from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
	light: {
		color: theme.palette.common.white,
	},
	dark: {
		color: theme.palette.common.black,
	},
	toolTip: {
		color: theme.palette.background
	}
}));

export default function HelpDialog({text, type, color="light"}) {
	const classes = useStyles();
	const [state, setState] = React.useState(false);

	const handleClickOpen = () => {
		setState(true);
	};

	const handleClose = () => {
		setState(false);
	};

	return (
		<div>
			{type === "tooltip"
			?
				<ClickAwayListener onClickAway={handleClose}>
					<Tooltip
					title={text}
					PopperProps={{
						disablePortal: true,
					}}
					onClose={handleClose}
					open={state}
					disableFocusListener
					disableHoverListener
					disableTouchListener
					arrow
				>
						<IconButton onClick={handleClickOpen} variant="inherited" className={color === "light" ? classes.light : classes.dark}>
							<HelpOutlineIcon />
						</IconButton>
					</Tooltip>
				</ClickAwayListener>
			: null
			}

			{type === "dialog"
			? <div>
					<IconButton onClick={handleClickOpen} variant="inherited" className={color === "light" ? classes.light : classes.dark}>
						<HelpOutlineIcon />
					</IconButton>
					<Dialog
						open={state}
						onClose={handleClose}
						TransitionComponent={Transition}
						keepMounted
						aria-labelledby="helpButton"
						aria-describedby="help-description"
					>
						<DialogTitle id="helpButton">
							{"Help!"}
						</DialogTitle>
						<DialogContent id="HelpDescription">
							<DialogContentText>
								{text}
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Fab
								id="remove"
								variant="extended"
								size="medium"
								label="remove"
								className={classes.fab}
								color="primary"
								onClick={handleClose}
							>
								Close
							</Fab>
						</DialogActions>
					</Dialog>
				</div>
			: null
			}
		</div>
	)
}